// extracted by mini-css-extract-plugin
module.exports = {"logo":"ThankYouPage_logo__2kyVC","page":"ThankYouPage_page__1XvcR","link":"ThankYouPage_link__1P0zr"};